// extracted by mini-css-extract-plugin
module.exports = {"root":"msgIcon_root__3vwwV","vague":"msgIcon_vague__3bPRt"};